export function Redeem() {
  return (
    <section className="section" id="redeem">
      <h2 className="section-title">How to redeem</h2>

      {/* Each step's content is one element: the list item is a grid, so a bare
          <b> beside a text node would become a second column. */}
      <ol className="steps">
        <li>
          <span>
            Play as far as Bloomville. Gift codes and the Mailbox are both locked until then.
          </span>
        </li>
        <li>
          <span>
            Open Settings with the gear icon, then the <b>Account</b> tab.
          </span>
        </li>
        <li>
          <span>
            Choose <b>Gift Code Redemption</b>, paste the code and press Redeem.
          </span>
        </li>
        <li>
          <span>Open your Mailbox and claim the reward.</span>
        </li>
      </ol>
    </section>
  );
}
